import { useQuery } from "@tanstack/react-query";

import { fetchModels } from "@/lib/api";

const MODELS_STALE_TIME_MS = 60 * 60 * 1000;

export function useModels() {
  return useQuery({
    queryKey: ["models"],
    queryFn: fetchModels,
    staleTime: MODELS_STALE_TIME_MS,
    gcTime: MODELS_STALE_TIME_MS * 2,
  });
}
